import { QuarterTerm } from './term.quarter.js';
import { SeasonTerm } from './term.season.js';
import { ZodiacTerm, SunSignTerm, StarSignTerm } from './term.zodiac.js';
import { EasternTerm, LunarSignTerm, EasternZodiacTerm } from './term.eastern.js';
import { TimelineTerm } from './term.timeline.js';
export { QuarterTerm, SeasonTerm, ZodiacTerm, SunSignTerm, StarSignTerm, EasternTerm, LunarSignTerm, EasternZodiacTerm, TimelineTerm, };
export const StandardTerms = [
    QuarterTerm,
    SeasonTerm,
    ZodiacTerm,
    EasternTerm,
    TimelineTerm,
];
